import React from 'react'
import HiddenField from 'components/fields/Hidden'
import BooleanField from 'components/fields/Boolean'
import TextField from 'components/fields/Text'
import ImmutableField from 'components/fields/Immutable'
import ProductSelectField from 'components/fields/ProductSelect'
import DateTimeField from 'components/fields/DateTime'

const fields = {
  boolean: BooleanField,
  hidden: HiddenField,
  immutable: ImmutableField,
  text: TextField,
  product: ProductSelectField,
  datetime: DateTimeField
}

const Field = props => {
  const Component = fields[props.field.type] || TextField

  return <Component {...props} />
}

export default Field



// WEBPACK FOOTER //
// ./src/components/fields/index.js